import { render, staticRenderFns } from "./OverflowList.vue?vue&type=template&id=d134e19e&scoped=true"
import script from "./OverflowList.vue?vue&type=script&lang=js"
export * from "./OverflowList.vue?vue&type=script&lang=js"
import style0 from "./OverflowList.vue?vue&type=style&index=0&id=d134e19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d134e19e",
  null
  
)

export default component.exports